import { Skeleton } from '@/components/ui';

export function SettingsForwardingSkeleton() {
  return (
    <div className="flex flex-col gap-5 px-5 py-5">
      {/* Status badge */}
      <div className="flex items-center gap-2">
        <Skeleton className="h-4 w-12" />
        <Skeleton className="h-5 w-24 rounded-full" />
      </div>

      {/* Toggle card */}
      <div className="flex items-center justify-between rounded-md border border-border bg-card p-4">
        <div className="flex flex-col gap-1.5">
          <Skeleton className="h-4 w-44" />
          <Skeleton className="h-3 w-56" />
        </div>
        <Skeleton className="h-6 w-10 rounded-full" />
      </div>
    </div>
  );
}
